import { QueryConfig } from "store/utils/query-config";

export const opportunitiesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["expectedCloseDate"]
  }
};
